





























































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Structure } from "@/api/models/structures/structure";
import CreateStructure from "./CreateStructure.vue";
import UpdateStructure from "./EditStructure.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateStructure,
    UpdateStructure,
  },
})
export default class ListStructures extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewStructureSidebarActive = false;
  isUpdateStructureSidebarActive = false;
  selectedStructureId = "";
  searchQuery = "";
  timeout: any = null;

  tableColumns = [{ key: "libelle", sortable: true, label: "libellé" }, { key: "actions" }];
  paginatedListStructures = new PaginatedList<Structure>();

  async created() {
    await this.loadListStructures({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListStructures.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListStructures.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListStructures({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  selectStructure(structureId: string) {
    this.$router.push({
      name: "details-structure",
      params: { id: structureId },
    });
  }

  editStructure(structureId: any) {
    this.selectedStructureId = structureId;
    this.isUpdateStructureSidebarActive = true;
  }

  @Watch('searchQuery')
  async searchStructures() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListStructures({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        search: this.searchQuery,
      })
    }, 1000);
  }

  async loadListStructures(params: any) {
    if (!params || params?.reset) {
      this.paginatedListStructures = new PaginatedList<Structure>();
    }
    await this.$http.myressif.structures
      .paginatedList(params?.search, params?.pageNumber ?? 1, params?.pageSize ?? 10)
      .then((response: PaginatedList<Structure>) => {
        this.paginatedListStructures = response;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cette structure ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.structures
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'une structure",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-structures");
        this.loadListStructures({
          search: this.searchQuery,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }
}
